var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.56 17.44 14.12 12l5.44-5.44a1.496 1.496 0 0 0 0-2.12 1.496 1.496 0 0 0-2.12 0L12 9.88 6.56 4.44a1.496 1.496 0 0 0-2.12 0 1.496 1.496 0 0 0 0 2.12L9.88 12l-5.44 5.44a1.496 1.496 0 0 0 0 2.12 1.496 1.496 0 0 0 2.12 0L12 14.12l5.44 5.44a1.496 1.496 0 0 0 2.12 0 1.503 1.503 0 0 0 0-2.12"
  })));
};
export default SvgClose;